export const NFTPORT_APIKEY = "88a0cba4-905c-482b-856e-1e449a6cda4f";
export const FLEEK_APIKEY = "i31SzU8ARQIu6Szr55r3Tg==";
export const FLEEK_APISECRET = "zkY6QF62QruO9DRGvX7C9yMz2pXQ5JvXSFLHZNCLJcA=";
export const PINATA_APIKEY = "22655435dd923c6b521c";
export const PINATA_SECRET_APIKEY = "b6b0f18b5ec0f992ba88312e90cc20fff45f0b30d6cafedb838df79707578fd4";